import { createSignal } from 'solid-js';

export type Theme = 'light' | 'dark';

const STORAGE_KEY = 'aiwb.theme';

function initialTheme(): Theme {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored === 'light' || stored === 'dark') return stored;
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

const [theme, setThemeSignal] = createSignal<Theme>(initialTheme());

// Paint the stored preference before the first render.
document.documentElement.dataset.theme = theme();

export function applyTheme(next: Theme): void {
  document.documentElement.dataset.theme = next;
  localStorage.setItem(STORAGE_KEY, next);
  setThemeSignal(next);
}

export function toggleTheme(): void {
  applyTheme(theme() === 'dark' ? 'light' : 'dark');
}

export { theme };
